const translations = require('../../assets/configs/babel/de.json')

window.__localization = {
  locale: 'de',
  translations: translations
}